import { useCartItemToDelete } from '@/features/pos/components/Cart/hooks/useCartItemToDelete'
import { useRemoveCartContainerItem } from '@/features/pos/components/Cart/hooks/useRemoveCartContainerItem'
import { useRemoveCartItem } from '@/features/pos/components/Cart/hooks/useRemoveCartItem'
import { unsetCartItemToDeleteId } from '@/features/pos/components/Cart/utils/cart-item-to-delete-id'
import { useCallback } from 'react'
import invariant from 'tiny-invariant'

export const useConfirm = (): (() => void) => {
    const removeItem = useRemoveCartItem()
    const removeContainerItem = useRemoveCartContainerItem()

    const cartItemToDelete = useCartItemToDelete()

    return useCallback(() => {
        invariant(cartItemToDelete, 'Cart item to delete must be set')

        if (cartItemToDelete.type === 'container') {
            removeContainerItem(cartItemToDelete.id)
        } else {
            removeItem(cartItemToDelete.id)
        }

        unsetCartItemToDeleteId()
    }, [cartItemToDelete, removeContainerItem, removeItem])
}
